import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BannerImage from "../components/img/neuro-science-banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import "../styles/pages.css";
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function Neurology() {
  const [activeSection, setActiveSection] = useState("overview");
  const [isFixed, setIsFixed] = useState(false);
  const sectionsRef = {
    overview: useRef(null),
    // treatment: useRef(null),
    // facilities: useRef(null),
    doctors: useRef(null),
  };
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleScroll = () => {
    const sections = [
      "overview", 
      // "treatment", 
      // "facilities", 
      "doctors"
    ];
    let currentSection = "";
    let setFix = false;
    for (let section of sections) {
      const ref = sectionsRef[section].current;
      const { top, bottom } = ref.getBoundingClientRect();
      const isInView =
        top <= window.innerHeight / 2 && bottom >= window.innerHeight / 2;
      if (top < 85) {
        setFix = true;
      } else {
        setFix = false;
      }
      if (isInView) {
        console.log("top", top, "bottom", bottom, "win", window.innerHeight);
        currentSection = section;
      }
    }
    setIsFixed(setFix);
    setActiveSection(currentSection);
  };

  // const scrollToSection = (section) => {
  //   sectionsRef[section].current.scrollIntoView({ behavior: "smooth",block:"center" });
  // };

  const scrollToSection = (section) => {
    const sectionElement = sectionsRef[section].current;
    if (sectionElement) {
      const offsetTop = sectionElement.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 100; // Adjust this value to match the height of your fixed header or sidebar
      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: "smooth",
      });
    }
  };


  useEffect(() => {
    handleScroll(); // Trigger once on load
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php?department=Neurology`);
        setDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);


  const navigate = useNavigate();

  const handleDoctorClick = (doctor) => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } })
  };

  return (
    <div>

      <Navbar />

      <section className="page-section">
        <div className="section-content">
          <p className='page-heading'>Neuro Science Department</p>

          <p className="page-subtitle">
           At Caritas Matha Neuro Sciences, we're passionate about guiding you 
           <br/>
           toward a lifetime of neuro health through expert care and innovation.
          </p>


          <div className="page-box">
            <div className="box-content">
              <p>Caritas Matha Hospital's Department of Neuro Sciences offers advanced neurology, neurosurgery, spine surgery, neuro-oncology and neuro-rehabilitation services. This neurology hospital is a one-stop center for all neurological issues. It has inpatient and outpatient wings, a daycare unit, dedicated neuro ICUs, neurosurgery suites, interventional neuroradiology and the most advanced imaging facilities, including nuclear medicine.</p>
            </div>
            <div className="box-image">
              <img src={BannerImage} alt="Dermatology Banner" />
            </div>
          </div>
        </div>
      </section>
      <section className="dept-section" >
        <div
          ref={sidebarRef}
          className={`sidebar-title ${!isFixed ? "fixed" : ""}`}
        >
          {[
            "overview", 
            // "treatment", 
            // "facilities", 
            "doctors"
          ].map((section) => (
            <p
              key={section}
              className={`title ${activeSection === section ? "active" : ""}`}
              onClick={() => scrollToSection(section)}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
              {activeSection === section && (
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="chevron-icon"
                />
              )}
            </p>
          ))}
        </div>
        <div ref={contentRef} className="contents">
          <div ref={sectionsRef.overview} className="overview-content">
            <p className="nuero-content-heading">Overview</p>
            {/* Overview content here */}
            <p>Epilepsy, strokes and other muscle-related ailments are some of the most significant contributors to India's cumulative neurological disability-adjusted life years (DALYs)—such a high metric warrants immediate and accurate treatment at par with international standards. A few decades back, even basic neurological examinations were hard to find in Kerala. This prompted the philanthropists in Kerala to initiate the neurology department at Caritas Matha hospital.</p>

            <p>Within a very short period, the quality of treatment provided by the team of neuro physicians, neurosurgeons, nurses and support staff supported by the best-in-class medical equipment earned Caritas the fame of the best neurological hospital in Kerala.</p>

            <p>The 24-hour emergency division caters to all types of neurological and neurosurgery emergencies, including complex neurotrauma and hyperacute management of stroke. It is another factor why this department makes Caritas the best neurology hospital in Kerala.</p>
          </div>
          {/* <div ref={sectionsRef.treatment} className="treatment-content">
            <p className="content-heading">Treatment</p>

            <p>Caritas Matha hospital provides a broad range of neurology treatments and procedures under the supervision of experienced neuro physicians. We use various diagnostic tests to help pinpoint the cause of symptoms and guide the selection of an appropriate treatment plan.</p>
            <br/>

            <p className="sub-heading">NeuroSurgery</p>

            <p>The Department of Neurosurgery in Caritas Matha Hospital offers a wide range of surgical procedures to treat various neurological disorders and accidents, including congenital disorders of the brain and spine, traumatic brain injury, spinal cord injuries and degenerative disc disorders.</p>

            <p>This department has highly experienced neurosurgical experts and spine surgeons to perform a range of simple to complex procedures, which are:</p>

            <ul>
              <li>Micro-neuro surgery for tumours & vascular disorders</li>
              <br/>
              <li>Awake craniotomy</li>
              <br/>
              <li>Minimal invasive surgery for spinal disorders - IVDP, microdiscectomy</li>
              <br/>
              <li>Emergency decompressive craniectomy and other emergency brain surgeries</li>
              <br/>
              <li>VP shunt procedures for hydrocephalus</li>
            </ul>
            <br/>

            
            <p className="sub-heading">Neurology</p>

            <p>The neurology department comprises a team of highly skilled physicians who have successfully diagnosed and treated neurological diseases, neuro infection and immunology, neuromuscular disorders and dementia.</p>

            <p>Our team is always up on their heels to provide immediate care for neurological incidents like acute ischemic stroke. We have the necessary facilities and experts to conduct mechanical thrombectomy therapy for acute strokes. The department uses a thrombolytic agent known as clot-busting drug to treat appropriate stroke patients.</p>

            <p>Regarded as one of the best neurology hospitals in Kerala, the neurology department is equipped with the following facilities:</p>

            <ul>
              <li>Electroencephalogram (EEG)</li>
              <br/>
              <li>Nerve Conduction Studies (NCS)</li>
              <br/>
              <li>Electromyography (EMG)</li>
              <br/>
              <li>Evoked Potential (VEP, SSEP, BERA)</li>
              <br/>
              <li>Video EEG Monitoring</li>
              <br/>
              <li>Cerebral Angiogram</li>
              <br/>
              <li>Carotid Doppler</li>
              <br/>
              <li>Plasmapheresis</li>
              <br/>
            </ul>

            
            <p className="sub-heading">Stroke Helpline</p>

            <p>The 24*7 active stroke helpline is arguably the only facility in Kerala that provides in-hospital brain imaging (CT/MRI) services, diagnoses and treats stroke patients within 30 minutes of their arrival in the hospital.</p>

            <p>The stroke helpline is equipped with the following facilities:</p>

            <ul>
              <li>CT Scanner</li>
              <br/>
              <li>1.5 Tesla MRI</li>
              <br/>
              <li>Hybrid Cath Lab</li>
              <br/>
              <li>Dedicated Neuro ICUs</li>
              <br/>
              <li>Integrated Neurosurgery Units</li>
            </ul>
            <br/>

            
            
            <p className="sub-heading">Movement Disorder, Parkinson's, and DBS Clinic</p>

            

            <p>Our comprehensive Movement Disorder, Parkinson's, and Deep Brain Stimulation Clinic offers specialized care and advanced treatment options for Parkinson's disease and a wide range of movement disorders, including dystonia, chorea, ataxia, tremor, and myoclonus.</p>

            <p style={{ fontSize: "18px", fontWeight: 600 }}>Services Include</p> 
            <ul>
              <li>Deep Brain Stimulation (DBS) Surgery for conditions such as Parkinson's disease,dystonia, and tremor.</li>
              <br/>

              <li>Botulinum Toxin Therapy for neurological disorders, including migraine and movement disorders.</li>
              <br/>

              <li>EMG-Guided Botulinum Toxin Injections for precise treatment of dystonia and spasticity.</li>
            </ul>

            <p>We are dedicated to delivering personalized care to improve the quality of life for our patients.</p>
            <br/>
          </div> */}
          {/* <div ref={sectionsRef.facilities} className="facilities-content">
            <p className="content-heading">Facilities</p>
            

            <p>Facilities The neurology department facilitates a range of diagnostics and therapeutic services such as neuropathies, neuropsychology services and others.</p>

            <ul>
              <li>Outpatient Neurology Clinic (6 days a week)</li>
              <br/>
              <li>Stroke Unit with Facility for Thrombolysis</li>
              <br/>
              <li>24 hr Emergency Services</li>
              <br/>
              <li>Intra-arterial & Endovascular Intervention for Stroke</li>
              <br/>
              <li>EEG Monitoring for Epilepsy</li>
              <br/>
              <li>Comprehensive Neuro Rehabilitation</li>
              <br/>
              <li>Speech and Language Therapy</li>
              <br/>
              <li>Comprehensive Care for Parkinson’s and Movement Disorders</li>
              <br/>
            </ul>
          </div> */}

          <div ref={sectionsRef.doctors} className="doctors">
            <p className="content-heading">Doctors</p>
            {doctors.length > 0 ? (
              <div className='doctorbox-container'>
                {doctors.map(doctor => (
                  <div key={doctor.id} className="doctorbox">
                    <div className="doctor-box">
                      <img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }} />
                      <div className='doctor-details'>
                        <h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
                        <p>{doctor['designation']}</p>
                        <p>{doctor.available_time}</p>
                        <br />
                        {parseInt(doctor.appointment_enabled) === 1 && (
                          <p>
                            <a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
                              Book An Appointment <FaChevronRight />
                            </a>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className='arrow-section'>
                      <FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }} />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p>No doctors available in this department.</p>
            )}
          </div>
        </div>
      </section>
      <Footer ref={footerRef} />
    </div>
  );
}

export default Neurology;